module.exports = __webpack_public_path__ + "static/img/2Act.f4878e25.png";